<template>
    <!-- 院民出入登记表 -->
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
          @submit.native.prevent>
          <el-form-item label="姓名">
            <el-input v-model.trim="formInline.oldName"  :clearable="true" placeholder="请输入姓名" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item label="离院日期">
            <el-date-picker :clearable="true" v-model="formInline.date" type="date" placeholder="请选择离院日期"
              value-format="yyyy-mm-dd" format="yyyy-mm-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addContract" plain>添加</el-button>
            <el-button
                type="info"
                @click="exportContract"
                icon="el-icon-download"
                plain>记录导出</el-button>
          </el-form-item>
        </el-form>
        <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
          <el-table-column prop="oldName" label="姓名" min-width="80"></el-table-column>
          <el-table-column prop="leaveDate" label="离院时间" min-width="150"></el-table-column>
          <el-table-column prop="desc" label="离院事由" min-width="100"></el-table-column>
          <el-table-column prop="returnDate" label="回院时间" min-width="100"></el-table-column>
          <el-table-column prop="family" label="家属签字" min-width="100"></el-table-column>
          <el-table-column prop="nurse" label="当班护理员" min-width="100"></el-table-column>
          <el-table-column prop="guard" label="门卫值守人员" min-width="100"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
          <el-table-column label="操作" min-width="80">
            <template slot-scope="scope">
              <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
                <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center" class="fenye">
        </el-pagination>


    <el-dialog
      :title="addForm.id == null ? '新增外出登记记录' : '修改外出登记表'"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="false"
    >
      <el-form
        :inline="true"
        :model="addForm"
        class="demo-form-inline"
        label-width="120px">
        <el-form-item label="老人姓名" prop="oldName">
         
          <el-autocomplete
            v-model.trim="addForm.oldName"
            auto-complete="off"
            placeholder="模糊搜索老人姓名"
            clearable
            style="width: 240px"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
          ></el-autocomplete>

        </el-form-item>
        <el-form-item label="离院日期" prop="oldSex">
          <el-date-picker
            v-model="addForm.leaveDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :readonly="addForm.id!=null && addForm.returnDate != ''"
            format="yyyy-MM-dd"
            style="width: 240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="离院事由">
          <el-input
            v-model="addForm.desc"
            placeholder="离院事由"
            style="width: 240px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="回院日期">
          <el-date-picker
            v-model="addForm.returnDate"
            type="date"
            placeholder="选择日期"
            :readonly="addForm.id!=null && addForm.returnDate != ''"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="家属签字">
          <el-input
            v-model="addForm.family"
            style="width: 240px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="当班护理员" prop="nurse">
          <el-input
            v-model="addForm.nurse"
            style="width: 240px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="门卫值守人" prop="guard">
          <el-input
            v-model="addForm.guard"
            style="width: 240px;"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark"
          style="width: 240px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDialogForm">确 定</el-button>
      </span>
    </el-dialog>

      </el-row>
    </div>
  </template>
  <script>
  import { baseURL } from "@/utils/request.js";
  export default {
    name: "ContractManage",
    data() {
      return {
        formInline: {
          oldName: "",
          oldmanId: null,
          year: "",
        },
        addForm:{},
        tableData: [], //表格数据
        oldmanList:[],
        defaultOldManList:[],
        tableLoading: false, //表格加载的loading
        /* 分页的 */
        currentPage: 1, //初始页
        pageNo: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber: 0, //数据的总数,
        fieldsVisisble: false,
        oldNameOptions: [], // 老人姓名集合
        dialogVisible:false,
      };
    },
    methods: {
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      
    /* 
      模糊搜索老人
    */
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var param = {
        pageNo:"1",
        pageSize:"1000",
      };
      this.$postJson("fmc/leaveRefund/queryOldmanList", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          this.defaultOldManList = list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.addForm.oldName = "";
          }, 100);
        }
      });
    },

    /* 
      选择老人
    */
    handleOlderSelect(item) {
      console.log(item);
      this.addForm.oldManId = item.oldmanId;
      this.addForm.oldName = item.oldName;
    },
      /*
        添加
      */
      addContract() {
        this.dialogVisible = true;
        this.addForm = {};
      },  
      handleEdit(index, row) {
          this.dialogVisible = true;
          this.addForm = Object.assign({}, row);

      },
      addDialogForm(){
        //omc/oldLeave/insert
        let param = this.addForm;
        this.$postJson(
          "fmc/leaveRefund/add",
          param
        ).then(res=>{
          if (res.code == 200) {
            this.dialogVisible = false;
            this.$message({ message: res.message, type: "success" });
            this.queryOut(); //刷新套餐列表的数据
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })

      },
      //导出
      exportContract() {
        // window.location.href =
        //   baseURL +
        //   `omc/api/downOldManContract?groupId=${window.sessionStorage.getItem("groupId")}`;
      
      },
      /*
        点击查询
      */
      search() {
        this.queryOut(
          this.formInline.oldmanId,
          this.formInline.year,
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
      },
     
      /*
        键盘事件 按下键盘回车 查询
      */
      enterSearchMember(e) {
        // console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.oldName != null) {
          this.search();
        }
      },
      /*
        查询老人分页列表
      */
      queryOut() {
        let params = {};
        if (this.formInline.oldmanId != "" || null || undefined) {
          params.oldmanId = this.formInline.oldmanId;
        }
        if(this.formInline.oldName == "" || null || undefined){
          params.oldmanId = null;
        }
        if (this.formInline.year != "" || null || undefined) {
          params.year = this.formInline.year;
        }
        params.pageNo = String(this.pageNo);
        params.pageSize = String(this.pageSize);
        this.tableData = [];
        this.tableLoading = true;
        this.$postJson("fmc/leaveRefund/showAll", params).then((res) => {
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.tableData = res.result.list;
            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 500);
        });
      },
      /*
        当前页变化
      */
      handleCurrentChange(val) {
        this.pageNo = val;
        this.queryOut(); //刷新套餐列表的数据
      },
    },
    mounted() {
      this.queryOut();
    },
    computed: {},
  };
  </script>
  <style lang="scss" scoped>
  .fenye {
    padding: 30px 0;
    background: #fff;
  }
  </style>
    